import { TextBoxIcon } from './TextBoxIcon';

/**
 * author: Google
 * id 32E03B3D-EAFA-4483-AE94-E43944F0F0AE
 * name text-box
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/text-box.svg
 * tags
 * - Files / Folders 
 */
export const DriveDocumentIcon = TextBoxIcon;
export default DriveDocumentIcon